jQuery(function($)
{
    const INTERVAL = 30000;

    var apiSessionUpdate = orion.api.sessionUpdate;
    var $customerIdMetaData = $('meta[name="customer_id"]');
    var $overlayLogin = $('#overlay-login');
    var $overlayMaintenance = $('#overlay-maintenance');
    var $overlayAccountChange = $('#overlay-account-change');
    var $body = $('body');
    var interval = null;

    if ($customerIdMetaData.length)
    {
        interval = setInterval(ajaxCall, INTERVAL);
    }

    function hideOverlay($overlay)
    {
        if ($overlay.length && !$overlay.hasClass('hidden'))
        {
            console.log($overlay);
            $overlay.addClass('hidden');
            $body.removeClass('focus-active');
        }
    }

    function ajaxCall()
    {
        apiSessionUpdate.ping($customerIdMetaData.attr('content'))
            .done(function(response, statusText, xhr)
            {
                if (xhr.status === 200)
                {
                    /*
					 * everything is ok.
					 * remove the login, maintenance or account change overlay if there is one
					 */
                    hideOverlay($overlayLogin);
                    hideOverlay($overlayMaintenance);
                    hideOverlay($overlayAccountChange);
                }
            })
            .fail(function(xhr)
            {
                switch (xhr.status)
                {
                case 403:
                    /*
						 * there is no login data in the session this is handled in global.js
						 * hide other overlays and reset the click handler from 409 if there is one
						 */
                    $overlayMaintenance.addClass('hidden');
                    $overlayAccountChange.addClass('hidden');
                    $body.off('click.409');
                    break;
                case 409:
                    // there is another login in the session show overlay and reload on click
                    $overlayLogin.addClass('hidden');
                    $overlayAccountChange.removeClass('hidden');
                    $body.addClass('focus-active');
                    $body.on('click.409', function()
                    {
                        $overlayAccountChange.addClass('hidden');
                        clearInterval(interval);
                        window.location.reload(true);
                        $body.off('click.409');
                    });
                    break;
                case 500:
                    // server fault keep on pinging
                    break;
                case 503:
                    // maintenance show overlay and prevent any click
                    $overlayMaintenance.removeClass('hidden');
                    $body.addClass('focus-active');
                    $body.on('click', function(e)
                    {
                        e.preventDefault();
                        e.stopPropagation();
                    });
                    break;
                }
            });
    }
});
